import { RotatingLines } from "react-loader-spinner";

const Loader = () => {
  return (
    <div
      className="flex items-center flex-col justify-center fixed top-0 bottom-0 left-0 right-0 z-[100] bg-modal-bg"
      style={{ background: "rgba(0,0,0,.32)" }}
    >
      <RotatingLines
        strokeColor="#0e76a8"
        strokeWidth="5"
        animationDuration="1"
        width="80"
        visible={true}
      />
      <p className="text-[#0e76a8] text-xl font-bold">Loading...</p>
    </div>
  );
};

export default Loader;
